// Eventos para o Google Tag Manager (Boards 4388). O GTM só é carregado no build de produção
// (public/index.html); nos demais ambientes os eventos ficam em window.dataLayer, para conferir
// no console. Nunca enviar dado pessoal (nome, CPF, e-mail, telefone).
function pushDataLayer(evento) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(evento);
}

export default pushDataLayer;
